<template>
  <div class="detail">
    <div class="back-to-home" @click="backToHome">返回</div>
    <div v-if="detail.navigationMp3Url" @click="handleMusicPlayOrPause" class="music-button"
         :class="[playing ? 'playing' : 'paused']"
         :style="mp3PlayOrStopImage"
    >
      <div v-if="playing" class="notes-container">
        <div class="note note-1" :style="mp3PlayColor"></div>
        <div class="note note-2" :style="mp3PlayColor"></div>
        <div class="note note-3" :style="mp3PlayColor"></div>
      </div>
      <audio ref="audio" id="audio" loop="loop" autoplay>
        <source :src="detail.navigationMp3Url" type="audio/mpeg">
      </audio>
    </div>
    <div class="detail-banner">
      <img :src="detail.listDetailsUrl" alt="">
      <div class="bg-overlay"
           :style="innerPageImageFrame"
      >
        <div class="banner-title">{{ detail.exhibitionName }}</div>
      </div>
    </div>
    <div class="detail-content"
         :style="innerTextBackBackground"
    >
      <div class="text-block" :style="[mainText,textFrame]">
        <p v-for="(p, i) in describeParagraphList" :key="i">{{ p }}</p>
      </div>
      <div class="detail-button-box">
        <PavilionButton class="pb" v-if="detail.travelPavilionl" :to-mp="travelToMp"
                        :pavilion="detail.childrenTravelPavilionlList[0]" @click="handleTravelLikeButtonClick('travel')"
                        :text="travelTitle"
                        :image-url="projectDetail.innerPageImages&&projectDetail.innerPageImages.travelPavilion"
                        :style="mainButton"
        >
        </PavilionButton>
        <PavilionButton class="pb" v-if="detail.partyHistory" @click="handleHistoryButtonClick"
                        :text="detail.partyHistoryText || '党史精读'"
                        :image-url="projectDetail.innerPageImages&&projectDetail.innerPageImages.partyHistory"
                        :style="mainButton"
        >
        </PavilionButton>
        <PavilionButton class="pb" v-if="detail.bookvisit" :to-mp="bookToMp" :pavilion="detail.childrenBookvisitList[0]"
                        :text="bookTitle" @click="handleBookButtonClick"
                        :image-url="projectDetail.innerPageImages&&projectDetail.innerPageImages.bookVisit"
                        :style="mainButton"
        >
        </PavilionButton>
        <PavilionButton class="pb" v-if="detail.answer" :to-mp="answerToMp" :pavilion="detail.childerAnswerList[0]"
                        :text="answerTitle" @click="handleTravelLikeButtonClick('answer')"
                        :image-url="projectDetail.innerPageImages&&projectDetail.innerPageImages.answer"
                        :style="mainButton"
        >
        </PavilionButton>
        <PavilionButton class="pb" v-if="detail.memoryHeroes" :to-mp="memoryHeroesToMp"
                        :pavilion="detail.childerMemoryHeroesList[0]" :text="detail.memoryHeroesText || '缅怀先烈'"
                        @click="handleTravelLikeButtonClick('remember')"
                        :image-url="projectDetail.innerPageImages&&projectDetail.innerPageImages.memoryHeroes"
                        :style="mainButton"
        >
        </PavilionButton>
      </div>
    </div>
    <Popup v-model="multiPavilionPopupVisible" :overlay-style="overlayStyle" position="bottom">
      <div class="popup__inner">
        <div class="popup-title">{{ popupTitle }}</div>
        <img class="popup-close-icon" src="../assets/icon_delete.png" alt="" @click="closePopup">
        <div class="popup-item-grid">
          <SubPavilionButton
            class="spb"
            v-for="(p, idx) in subPavilionList"
            :toMp="p.buttonType === 3 && p.appId"
            :key="idx"
            @click="handleSubPavilionClick(p)"
            :pavilion="p"
          />
        </div>
      </div>
    </Popup>
    <Overlay style="background-color: rgba(0,0,0,.6)" :show="travelInfoVisible" :lock-scroll="false">
      <div class="book-info-dialog"
           :style="windowBottomBackground">
        <img class="dialog-close" src="../assets/icon_delete.png" alt="" @click="travelInfoVisible = false">
        <div class="dialog-title"></div>
        <div class="dialog-content">
          <div class="info-placeholder">
            <div class="info-placeholder__title">{{ currentSubPavilion.childrenExhibitionName }}</div>
            <img class="info-placeholder__image" src="../assets/icon_empty.png"/>
            <div class="info-placeholder__text">{{ currentSubPavilion.popText || '展馆建设中，敬请期待...' }}</div>
          </div>
        </div>
      </div>
    </Overlay>
    <Overlay style="background-color: rgba(0,0,0,.6)" :show="bookInfoVisible" :lock-scroll="false">
      <div class="book-info-dialog"
           :style="windowBottomBackground">
        <img class="dialog-close" src="../assets/icon_delete.png" alt="" @click="bookInfoVisible = false">
        <div class="dialog-title">{{ bookTitle }}</div>
        <div class="dialog-content">
          <template v-if="currentSubPavilion.childrenExhibitionName">
            <div class="info-title">
              <img class="info-title-icon"
                   :src="projectDetail.innerPageImages&&projectDetail.innerPageImages.exhibitionName" alt="">
              展馆名称
            </div>
            <div class="info-text">{{ currentSubPavilion.childrenExhibitionName }}</div>
          </template>
          <template v-if="currentSubPavilion.openTime">
            <div class="info-title">
              <img class="info-title-icon" :src="projectDetail.innerPageImages&&projectDetail.innerPageImages.openTime"
                   alt="">
              开放时间
            </div>
            <div class="info-text">{{ currentSubPavilion.openTime }}</div>
          </template>
          <template v-if="currentSubPavilion.address">
            <div class="info-title">
              <img class="info-title-icon"
                   :src="projectDetail.innerPageImages&&projectDetail.innerPageImages.exhibitionAddress" alt="">
              展馆地址
            </div>
            <div @click="gotoMap" class="info-text"
                 :class="{clickable: currentSubPavilion.longitude && currentSubPavilion.latitude}">
              {{ currentSubPavilion.address }}
            </div>
          </template>
          <template v-if="currentSubPavilion.phone">
            <div class="info-title">
              <img class="info-title-icon" :src="projectDetail.innerPageImages&&projectDetail.innerPageImages.bookWay"
                   alt="">
              预约方式
            </div>
            <div class="info-text">
              <span v-for="(t, i) in phoneTextList" :key="i" :class="{clickable: t.matched}"
                    @click="makeCall(t)">{{ t.text }}</span>
            </div>
          </template>
        </div>
      </div>
    </Overlay>
    <Overlay :show="loading" style="background: rgba(0,0,0,.6)">
      <div class="loading__inner">
        <Loading color="rgba(255,255,255,0.6)"/>
      </div>
    </Overlay>
  </div>
</template>

<script>
import { Loading, Overlay, Popup } from 'vant'
import { getExhibitionDetail, getProjectDetail, getPreviewDetail } from '@/api'
import initWxShare from '@/utils/wx'
import loadjs from 'loadjs'
import { WX_JSAPI_URL } from '@/utils/constants'
import { isNfPlus } from '@/utils/env'
import PavilionButton from '@/components/PavilionButton'
import SubPavilionButton from '@/components/SubPavilionButton'
import { mapGetters } from 'vuex'
import { setDocumentTitle } from '@/utils/dom'

export default {
  name: 'Detail',
  components: {
    SubPavilionButton,
    PavilionButton,
    Overlay,
    Loading,
    Popup,
  },
  data () {
    return {
      loading: true,
      playing: true,
      detail: {},
      travelInfoVisible: false,
      bookInfoVisible: false,
      multiPavilionPopupVisible: false,
      popupType: 'yyzg',
      overlayStyle: {
        background: 'rgba(0, 0, 0, .6)',
      },
      currentSubPavilion: {},
      popupTitle: '',
      subPavilionList: [],
      projectDetail: {},
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    },
    projectId () {
      return this.$route.query.projectId
    },
    previewId () {
      return this.$route.query.previewId
    },
    travelToMp () {
      const travel = this.detail.childrenTravelPavilionlList?.[0]
      return !!(this.detail.childrenTravelPavilionlList?.length === 1 && travel && travel.buttonType === 3 && travel.appId)
    },

    bookToMp () {
      const book = this.detail.childrenBookvisitList?.[0]
      return !!(this.detail.childrenBookvisitList?.length === 1 && book && book.buttonType === 3 && book.appId)
    },
    memoryHeroesToMp () {
      const book = this.detail.childerMemoryHeroesList?.[0]
      return !!(this.detail.childerMemoryHeroesList?.length === 1 && book && book.buttonType === 3 && book.appId)
    },
    answerToMp () {
      const book = this.detail.childerAnswerList?.[0]
      return !!(this.detail.childerAnswerList?.length === 1 && book && book.buttonType === 3 && book.appId)
    },
    describeParagraphList () {
      return (this.detail.describe || '').split('\n')
    },
    travelTitle () {
      return this.detail.travelPavilionlText || '云游展馆'
    },
    bookTitle () {
      return this.detail.bookvisitText || '预约参观'
    },
    answerTitle () {
      return this.detail.answerText || '打卡答题'
    },
    rememberTitle () {
      return this.detail.memoryHeroesText || '缅怀英烈'
    },
    phoneTextList () {
      const list = []
      let phone = this.currentSubPavilion.phone || ''
      const phoneNumberMatch = phone?.match(/((\+?86)?1[3-9](\d{9})|((\d+-)?\d{7,8}))/g)
      if (phoneNumberMatch?.length) {
        phoneNumberMatch.forEach(p => {
          const pIdx = phone.indexOf(p)
          if (pIdx > -1) {
            list.push({ text: phone.substr(0, pIdx) })
            phone = phone.substring(pIdx + p.length)
            list.push({
              text: p,
              matched: true,
            })
          }
        })
      }
      list.push({ text: phone })
      return list.filter(t => t.text)
    },
    // 主要文字颜色
    mainButton () {
      return { backgroundImage: 'linear-gradient(180deg,'.concat(this.projectDetail?.colors?.mainButtonStart, ' 0%, ', this.projectDetail?.colors?.mainButtonEnd, ' 100%)') }
    },
    // 正文上下框
    textFrame () {
      return {
        background: 'url('.concat(this.projectDetail?.innerPageImages?.textUpFrame, ')', ' 0 0 / 1.26rem 1.18rem no-repeat',
          ',url(', this.projectDetail?.innerPageImages?.textUnderFrame, ')', ' right 0 bottom 0 / 1.26rem 1.18rem no-repeat'),
      }
    },
    // 各类子弹窗背景
    windowBottomBackground () {
      return { background: 'url('.concat(this.projectDetail?.innerPageImages?.windowBottomBackgroundImage, ')', 'bottom right / 4.8rem 2.4rem no-repeat,', 'linear-gradient(180deg,', this.detailColors?.projectBackgroundStart, ' 0%, ', this.detailColors?.projectBackgroundEnd, ' 100%)') }
    },
    // mp3动画颜色
    mp3PlayColor () {
      return { backgroundColor: this.projectDetail?.mp3PlayColor }
    },
    // 音乐播放和停止背景图
    mp3PlayOrStopImage () {
      return { backgroundImage: 'url(\'' + (this.playing === true ? this.projectDetail?.innerPageImages?.mp3Play : this.projectDetail?.innerPageImages?.mp3Stop) + '\')' }
    },
    // 内页图片框
    innerPageImageFrame () {
      return { backgroundImage: 'url(\'' + (this.projectDetail?.innerPageImages?.innerPageImageFrame) + '\')' }
    },
    // 内页正文背景
    innerTextBackBackground () {
      return { backgroundImage: 'url(\'' + (this.projectDetail?.innerPageImages?.innerTextBackBackground) + '\')' }
    },
    // 主要文字颜色
    mainText () {
      return { color: this.projectDetail?.colors?.mainText }
    },
  },
  async mounted () {
    if (this.id || this.previewId) {
      await this.fetchProject()
      await this.fetchDetail()
      if (isNfPlus()) {
        try {
          // 端内分享
          window.nfplusJsbridge.setShareInfo({
            shareTitle: this.detail.exhibitionName,
            shareDesc: this.detail.describe,
            shareIcon: this.detail.listDetailsUrl?.replace('http://', 'https://'),
            shareUrl: window.location.href,
          })
        } catch (e) {
          console.log(e)
        }
      }
      this.loading = false
      if (this.detail.navigationMp3Url) {
        this.$nextTick(() => {
          this.initMusic()
        })
      }
      if (!this.$root.wxLoaded) {
        await loadjs([WX_JSAPI_URL], { returnPromise: true }).then(() => {
          this.$root.wxLoaded = true
          return initWxShare({
            title: this.detail.exhibitionName,
            desc: this.detail.describe,
            imgUrl: this.detail.listDetailsUrl?.replace('http://', 'https://'),
            link: window.location.href,
          })
        }).catch(() => {
        })
      } else {
        await initWxShare({
          title: this.detail.exhibitionName,
          desc: this.detail.describe,
          imgUrl: this.detail.listDetailsUrl?.replace('http://', 'https://'),
          link: window.location.href,
        }).catch(() => {
        })
      }
    } else {
      this.$toast('此展馆未开放！')
    }
    if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge?.invoke === 'function') {
      this.handleFontSize()
    } else {
      document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false)
    }
  },
  methods: {
    fetchProject () {
      getProjectDetail(this.projectId).then(res => {
        this.projectDetail = res.data
        // 手动设置标题
        setDocumentTitle(this.projectDetail.projectName)
      })
    },
    fetchDetail () {
      if (this.previewId) {
        return getPreviewDetail(this.previewId).then(res => {
          this.detail = res.data || {}
        })
      } else {
        return getExhibitionDetail(this.id).then(res => {
          this.detail = res.data || {}
        })
      }
    },
    backToHome () {
      const isFromHome = sessionStorage.getItem('red_pavilion_from_home')
      if (isFromHome !== '1') {
        this.$router.replace({
          name: 'Home',
          query: {
            id: this.detail.projectId,
          },
        })
      } else {
        this.$router.go(-1)
      }
    },
    getListDataByType (type) {
      let listName = ''
      let popupTitle = ''
      switch (type) {
        case 'travel':
          listName = 'childrenTravelPavilionlList'
          popupTitle = this.travelTitle
          break
        case 'book':
          listName = 'childrenBookvisitList'
          popupTitle = this.bookTitle
          break
        case 'answer':
          listName = 'childerAnswerList'
          popupTitle = this.answerTitle
          break
        case 'remember':
          listName = 'childerMemoryHeroesList'
          popupTitle = this.rememberTitle
          break
        default:
      }
      return [listName, popupTitle]
    },
    handleTravelLikeButtonClick (type) {
      const [listName, popupTitle] = this.getListDataByType(type)
      this.popupTitle = popupTitle
      const list = this.detail[listName] || []
      this.subPavilionList = list
      this.popupType = 'yyzg'
      if (list.length === 1) {
        this.currentSubPavilion = list[0] || {}
        if (this.currentSubPavilion.buttonType === 1) {
          this.travelInfoVisible = true
        } else if (this.currentSubPavilion.buttonType === 2 && this.currentSubPavilion.articleLink) {
          window.location.href = isNfPlus() ? (this.currentSubPavilion.articleLink?.jumpUrl || this.currentSubPavilion.articleLink?.shareUrl) : this.currentSubPavilion.articleLink?.shareUrl
        }
      } else if (list.length > 1) {
        this.multiPavilionPopupVisible = true
      }
    },
    handleHistoryButtonClick () {
      if (this.detail.partyHistoryUrl) {
        window.location.href = isNfPlus() ? (this.detail.partyHistoryUrl?.jumpUrl || this.detail.partyHistoryUrl?.shareUrl) : this.detail.partyHistoryUrl?.shareUrl
      }
    },
    handleBookButtonClick () {
      this.popupType = 'yycg'
      this.popupTitle = this.bookTitle
      this.subPavilionList = this.detail.childrenBookvisitList || []
      if (this.detail.childrenBookvisitList?.length === 1) {
        this.currentSubPavilion = this.detail.childrenBookvisitList?.[0] || {}
        if (this.currentSubPavilion.buttonType === 1) {
          this.bookInfoVisible = true
        } else if (this.currentSubPavilion.buttonType === 2 && this.currentSubPavilion.articleLink) {
          window.location.href = isNfPlus() ? (this.currentSubPavilion.articleLink?.jumpUrl || this.currentSubPavilion.articleLink?.shareUrl) : this.currentSubPavilion.articleLink?.shareUrl
        }
      } else if (this.detail.childrenBookvisitList?.length > 1) {
        this.multiPavilionPopupVisible = true
      }
    },
    closePopup () {
      this.multiPavilionPopupVisible = false
    },
    handleSubPavilionClick (p) {
      this.currentSubPavilion = p
      this.multiPavilionPopupVisible = false

      if (p.buttonType === 1) {
        if (this.popupType === 'yyzg') {
          this.travelInfoVisible = true
        } else if (this.popupType === 'yycg') {
          this.bookInfoVisible = true
        }
      } else if (p.buttonType === 2) {
        window.location.href = isNfPlus() ? (this.currentSubPavilion.articleLink?.jumpUrl || this.currentSubPavilion.articleLink?.shareUrl) : this.currentSubPavilion.articleLink?.shareUrl
      } else if (p.buttonType === 3) {
        // 小程序处理
      }
    },
    handleFontSize () {
      window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      window.WeixinJSBridge.on('menu:setfont', function () {
        window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      })
    },
    gotoMap () {
      const {
        latitude,
        longitude,
        childrenExhibitionName,
        address,
      } = this.currentSubPavilion
      if (address && longitude && latitude) {
        window.open(`https://uri.amap.com/marker?position=${longitude},${latitude}&name=${childrenExhibitionName}&src=yourAppName`, '__blank')
      }
    },
    makeCall (t) {
      if (t.matched) {
        window.location.href = `tel:${t.text}`
      }
    },
    playMusic () {
      if (this.$refs.audio && this.$refs.audio.paused) {
        this.$refs.audio.play()
      }
    },
    handleMusicPlayOrPause () {
      if (!this.$refs.audio) {
        return
      }
      this.$refs.audio.paused ? this.$refs.audio.play() : this.$refs.audio.pause()
    },
    initMusic () {
      console.log('初始化音乐')
      const audio = this.$refs.audio
      if (!audio) {
        return
      }
      audio.addEventListener('playing', () => {
        console.log('播放音乐')
        this.playing = true
      })

      audio.addEventListener('pause', () => {
        console.log('暂停音乐')
        this.playing = false
      })

      audio.load()

      audio.onload = () => {
        console.log('audio load')
        this.playMusic()
      }

      setTimeout(() => {
        this.playMusic()
      })

      document.addEventListener(
        'WeixinJSBridgeReady',
        () => {
          // console.log('WeixinJSBridgeReady')
          this.playMusic()
        },
        false,
      )

      const play = () => {
        console.log('touch start')
        this.playMusic()
        if (audio && !audio.paused) {
          document.removeEventListener('touchstart', play)
        }
      }

      document.addEventListener('touchstart', play)
    },
  },
}
</script>

<style lang="less" scoped>
.detail {
  position: relative;

  ::v-deep {
    .van-popup {
      background: transparent;
    }
  }
}

.back-to-home {
  position: fixed;
  left: 0;
  top: 0.3rem;
  z-index: 1;
  background: rgba(0, 0, 0, 0.40);
  border-radius: 0 32px 32px 0;
  width: 1rem;
  height: 0.64rem;
  line-height: 0.64rem;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  color: #FFFFFF;
}

.detail-banner {
  position: relative;
  width: 100%;
  height: 4.4rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.bg-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: ~'url("../assets/pic_bg.png") 0 0 / 100% 100% no-repeat';
}

.banner-title {
  font-family: FZZDHJW;
  font-size: 0.46rem;
  color: #FFFFFF;
  position: absolute;
  bottom: 0.17rem;
  left: 0.4rem;
  right: 0.4rem;
}

.detail-content {
  min-height: calc(100vh - 4.4rem);
  background: url("../assets/bg2.png") 0 0 / cover no-repeat;
  padding: 0.12rem 0.5rem 0;
  padding-bottom: 0.4rem;
  padding-bottom: calc(0.4rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(0.4rem + env(safe-area-inset-bottom));
}

.text-block {
  font-family: PingFangSC-Regular;
  padding: 0.2rem;
  font-size: 0.26rem;
  line-height: 0.37rem;
  color: #FFDCA3;
  //background: ~'url("../assets/tag_text_left.png") 0 0 / 1.26rem 1.18rem no-repeat, url("../assets/tag_text_right.png") right 0 bottom 0 / 1.26rem 1.18rem no-repeat';
}

.detail-button-box {
  margin-top: 0.4rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}

.book-info-dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  margin-top: -0.08rem;
  width: 5.9rem;
  height: 7.66rem;
  background: ~'url("../assets/bg_dialog.png") bottom right / 4.8rem 2.4rem no-repeat, linear-gradient(180deg, #FF5837 0%, #B8301A 100%)';
  border-radius: 0.1rem;
}

.dialog-close {
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  width: 0.3rem;
  height: 0.3rem;
}

.dialog-title {
  ont-family: PingFang-SC-Bold;
  font-size: 0.36rem;
  font-weight: bold;
  color: #FFDCA3;
  text-align: center;
  line-height: 0.5rem;
  margin-top: 0.4rem;
}

.dialog-content {
  margin-top: 0.3rem;
  width: 100%;
  padding: 0 0.4rem 0.3rem;
  height: calc(100% - 1.3rem);
  overflow: auto;

  .info-title {
    font-family: PingFang-SC-Bold;
    font-size: 0.3rem;
    line-height: 0.42rem;
    color: #FFDCA3;
    display: flex;
    align-items: center;
    font-weight: bold;

    &:not(:first-child) {
      margin-top: 0.3rem;
    }
  }

  .info-title-icon {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.1rem;
  }

  .info-text {
    padding-left: 0.42rem;
    margin-top: 0.1rem;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #FFFFFF;

    &.clickable, .clickable {
      text-decoration: underline;
    }
  }

  .info-placeholder {
    margin-top: 0.32rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__title {
      font-family: PingFang-SC-Bold;
      font-size: 0.36rem;
      line-height: 0.5rem;
      color: #FFDCA3;
      text-align: center;
    }

    &__image {
      margin-top: 0.94rem;
      width: 1.5rem;
      height: 1rem;
    }

    &__text {
      margin-top: 0.2rem;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: rgba(255, 255, 255, 0.46);
    }
  }
}

.loading__inner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup__inner {
  position: relative;
  overflow: auto;
  width: 100%;
  background-image: linear-gradient(180deg, #FF5837 0%, #B8301A 100%);
  border-radius: 0.4rem 0.4rem 0 0;
}

.popup-title {
  width: 100%;
  margin: 0.4rem 0;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  line-height: 0.42rem;
  color: #FFDCA3;
}

.popup-close-icon {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  width: 0.3rem;
  height: 0.3rem;
}

.popup-item-grid {
  width: 100%;
  padding: 0 0.4rem 0.3rem 0.4rem;
  height: 5.62rem;
  overflow: auto;
  padding-bottom: 0.4rem;
  padding-bottom: calc(0.4rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(0.4rem + env(safe-area-inset-bottom));

}

.pb {
  &:not(:first-child) {
    margin-top: 0.4rem;
  }
}

.spb {
  &:not(:first-child) {
    margin-top: 0.2rem;
  }
}

.music-button {
  position: fixed;
  top: 0.3rem;
  right: 0.3rem;
  z-index: 1;
  width: 0.64rem;
  height: 0.64rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 1;

  &.playing {
    background-image: url("../assets/icon_voice_on.png");
  }

  &.paused {
    background-image: url("../assets/icon_voice_off.png");
  }
}

.notes-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .note {
    margin-top: -0.02rem;
    flex-shrink: 0;
    height: 0.07rem;
    width: 0.03rem;
    border-radius: 0.02rem;
    background-color: #FB4644;

    &:not(:first-child) {
      margin-left: 0.03rem;
    }
  }

  .note-1, .note-3 {
    animation: side-anime 1s infinite;
  }

  .note-2 {
    animation: mid-anime 1s infinite;
  }

}

@keyframes side-anime {
  0%, 100% {
    height: 0.07rem;
  }
  50% {
    height: 0.12rem;
  }
}

@keyframes mid-anime {
  0%, 100% {
    height: 0.12rem;
  }
  50% {
    height: 0.07rem;
  }
}
</style>
